<template>
  <input :id="formId" v-model="internalValue" type="checkbox" class="toggle" :disabled="disabled" :style="`--toggle-content:'${title}'`">
</template>

<style lang="scss">
.toggle {
  --toggle-size: 32px;
  --toggle-content: '';
  appearance: none;
  min-width: calc(var(--toggle-size) * 1.5625);
  width: fit-content;
//  max-width: 60px;
  height: var(--toggle-size);
  position: relative;
  background: var(--med-bgcolor);
  border-radius: calc(var(--toggle-size) * 0.50);
  cursor: pointer;
  box-shadow: inset 0 0 5px rgba(128,128,128,0.5);
  transition: all 0.74s ease;
  margin-top: 0;
  margin-bottom: 0;
  
  &:disabled {
    &:after { background: var(--button-disabled-bgcolor);};
  };
  
  &:focus {
    outline: none;
    
    &:after {
      box-shadow: 0 0 4px rgba(255,255,255,0);
    }
  }
  
  // Label
  &:before {
    content: var(--toggle-content);
    padding: 1ex;
    padding-left: var(--toggle-size);
    padding-right: calc(var(--toggle-size) / 2);
    line-height: var(--toggle-size);
    color: var(--text-color);
    transition: padding 0.14s ease-out;
  }
  &:checked:before { 
    color: #fff;
    padding-left: calc(var(--toggle-size) / 2);
    padding-right: var(--toggle-size);
  }
  
  // Thumb
  &:after {
    content: '.';
    text-indent: -9999px;
    display: block;
    position: absolute;
    top: 50%;
    left: 4px;
    transform: translateY(-50%);
    width:  calc(var(--toggle-size) - 8px);
    height: calc(var(--toggle-size) - 8px);
    background: var(--neg-bgcolor);
    border-radius: 50%;
    transition: left 0.14s ease-out;
  }
  
  &:checked {
    background: var(--accent-color);
    
    &:after {
      left: unset;
      left: calc(100% - var(--toggle-size) + 4px);
    }
  };
  
  &.mini {
    --toggle-size: 22px;
  }
  
}
</style>

<script>
import { nextTick } from 'vue'
export default {
  name: 'ToggleSwitch',
  emits: ['input', 'update:modelValue'],
  
  props: {
    modelValue: {
    },
    
    formId: {
      type: String
    },
    
    title: {
      type: String,
      default: () => ''
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },
  
  data() {
    return {
      internalValueLock: false,
      internalValue: this.modelValue
    }
  },
  
  computed: {
    value() { return this.internalValue}
  },
  
  watch: {
    modelValue(newVal) {
      this.setInternalValueFromValue();
    },
    
    internalValue(val) {
      if (this.internalValueLock) 
        return;

      this.$emit('update:modelValue', val);
      this.$emit('input', {type: 'toggle', target: this})
    }
  },
  
  created() {
    this.setInternalValueFromValue();
  },
  
  mounted() {
    this.setInternalValueFromValue();
  },
  
  methods: {
    setInternalValueFromValue() {
      this.internalValueLock = true;
      nextTick(() => {
        nextTick(() => {
          this.internalValue = this.modelValue;
          this.internalValueLock = false;
        });
      });
    }
  }
}
</script>
